import { useEffect, useRef } from 'react';

export default function MouthpieceReport() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .fade-up-item, .fade-left, .fade-right, .scale-in').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const features = [
    '歯並びの状態',
    'マウスピース矯正の適性',
    '生活習慣・性格(装着時間、管理のしやすさ)',
    '骨格や顎の状態',
    '過去の歯科治療との整合性',
    '費用や期間が変わるポイント',
  ];

  return (
    <section ref={sectionRef} id="report" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-3xl md:text-4xl font-normal text-center text-gray-900 mb-4 fade-up font-serif"
        >
          判断を助ける<br />
          《あなた専用 矯正プラン比較レポート》の提示
        </h2>

        <div className="flex justify-center my-12 scale-in px-4">
          <img
            alt="矯正プラン比較レポート"
            className="max-w-xs md:max-w-md w-full h-auto rounded-lg shadow-lg"
            src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-1649x1878_v-frms_webp_bfc64f58-af11-440b-b5a7-e0dc193232f2_small.webp"
          />
        </div>

        <h3 className="text-2xl font-bold text-center text-gray-900 mb-8 fade-up font-serif">
          《あなた専用矯正プラン比較レポート》を無料提供
        </h3>
        <p className="text-center text-lg text-gray-700 mb-8 fade-up">このレポートでは、</p>

        <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto mb-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg fade-up-item"
            >
              <div
                className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-1"
                style={{ backgroundColor: '#3E5F8F' }}
              >
                <i className="ri-check-line text-white text-xs" />
              </div>
              <p className="text-gray-800">{feature}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-700 mb-10 fade-up">
          など、他院では有料級の情報を無料で提供しています。
        </p>

        <div className="text-center fade-up">
          <a
            href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: '#3E5F8F' }}
          >
            無料診断を予約する(レポート作成)
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-12 flex justify-center scale-in px-4">
          <img
            alt="レポートサンプル"
            className="max-w-xs md:max-w-sm w-full h-auto rounded-lg shadow-md"
            src="https://storage.googleapis.com/studio-design-asset-files/projects/Kwa5AGrYaX/s-1856x2113_v-frms_webp_90955c9c-fd92-4835-a66d-09a989961acb_small.webp"
          />
        </div>
      </div>
    </section>
  );
}